<div class="dialog-box card">
  <div class="card-header">
    Primary Monitoring Company
    <span class="float-end" (click)="onCloseDialogue()">
      <i class="fa-solid fa-xmark"></i>
    </span>
  </div>

  <div class="p-2 mb-3">
    Alarm responses will default to the primary monitoring company.
  </div>

  <div>
    @if (selectedMonitoringCompany?.id) {
      <div class="py-4">
        <div class="d-flex align-items-center gap-4 justify-content-center">
          <span>
            {{ selectedMonitoringCompany?.company_name }}
          </span>
          <span
            (click)="selectedMonitoringCompany = {}; editField()"
            class="mx-0 edit-button"
          >
          </span>
          <span (click)="onCloseDialogue('remove')"
            ><i class="fa-solid fa-circle-minus text-danger fs-5"></i
          ></span>
        </div>
      </div>
    } @else {
      <gtapp-auto-complete
        [data]="monitoringCompanyListData"
        placeHolder="Monitoring Company"
        searchKeyword="company_name"
        inputId="monitoringCompanyLookupFieldId"
        [itemTemplate]="monitoringCompanyLookupTemplate"
        [initialValue]="monitoringCompanyStringValue"
        [addInitialKey]="!!monitoringCompanyStringValue.length"
        (inputChanged)="onMonitoringCompanyLookup($event)"
        (selected)="onSelectMonitoringCompany($event)"
        [enableCloseOption]="true"
        (fieldCleared)="editField()"
      >
      </gtapp-auto-complete>
      <ng-template #monitoringCompanyLookupTemplate let-item>
        @if (item?.key === 0) {
          <div>Add Monitoring Company</div>
        } @else {
          <div>
            {{ item.company_name }}
          </div>
        }
      </ng-template>
    }
  </div>
</div>
